// Dependencies
import Helmet from 'react-helmet';
import styled, { createGlobalStyle } from 'styled-components'
 
// Demo data
import buggy from './dev/data/buggyData.json'
import variable from './dev/data/variableData.json'
import simple from './dev/data/simpleData.json'
import bundle from './dev/data/bundleData.json'
import theme from './dev/data/theme.json'
import config from './dev/data/config.json'
import translations from './dev/data/translations.json'

export const GlobalStyles = createGlobalStyle<any>`
  body {
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    margin-top: 30em;
    overflow: auto;
    display: grid;
    padding: 3em 0;
    background: #575757;
    //background-color: rgb(32, 32, 32);
    font-family: 'Rubik';
  }

  /* #wooptima-product-area {
    width: 100%;
    max-width: 595px;
    padding: 2em 2em;
    background-color: #fff;
    box-shadow: 0 0 2em rgba(#000, 1);
    resize: horizontal;
    overflow: auto;
  } */
`

export const StyleSheets = ({url}: {url: string}) => (
  <Helmet>
    <link href={url} rel='stylesheet' cross-origin />
  </Helmet>
)

export const Header = styled.header`
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
`

export const HeaderRow = styled.div<any>`
  width: 100%;
  padding: 0 2rem;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: ${(p) => p?.bgColor ?? '#fff'};
  color: ${(p) => p?.textColor ?? '#000'};
  height: ${(p) => p?.height ?? 'unset'};

`
export const Content = styled.div`
  width: 100%;
  padding: 2rem;
`

export const Container = styled.div<any>`
  width: 100%;
  height: 100%;
  display: flex;
  max-width: 780px;
  margin: auto;
`

export const DemoLogo = styled.div`
  font-size: 1.5em;
  padding: 1em 0;
  color: #000000;
`

export const DemoContent = () => {
  return (
    <main className="demo-content">
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dicta
        voluptatum, reiciendis ipsa in, magni a cum beatae similique sint, quis
        vero vitae. Magnam, tenetur possimus! Iste qui ipsa commodi sunt non,
        accusantium vitae autem provident odit fuga dolore cumque exercitationem
        totam nesciunt error aliquam vel laborum, dolorum quas ullam sed
        consequuntur obcaecati natus? Necessitatibus voluptate, cum ipsum nihil
        vero voluptatem placeat ad quos maxime nisi rerum quibusdam, ea
        explicabo repellat consequuntur laboriosam eius nulla. Accusamus
        blanditiis quod placeat temporibus, tempora, assumenda consequuntur qui
        vero tenetur sunt vitae laudantium officia, distinctio beatae ex
        consequatur minima autem quas ullam non repellendus! Expedita.
      </p>
      <p>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Blanditiis
        illum debitis suscipit nostrum dignissimos impedit molestias ea,
        deleniti eum officia.
      </p>
      <p>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum sit,
        beatae nemo animi quos exercitationem nesciunt libero! Pariatur
        accusamus id quisquam laudantium assumenda quaerat veritatis, quod sint
        qui incidunt corrupti.
      </p>
      <p>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum sit,
        beatae nemo animi quos exercitationem nesciunt libero! Pariatur
        accusamus id quisquam laudantium assumenda quaerat veritatis, quod sint
        qui incidunt corrupti.
      </p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dicta
        voluptatum, reiciendis ipsa in, magni a cum beatae similique sint, quis
        vero vitae. Magnam, tenetur possimus! Iste qui ipsa commodi sunt non,
        accusantium vitae autem provident odit fuga dolore cumque exercitationem
        totam nesciunt error aliquam vel laborum, dolorum quas ullam sed
        consequuntur obcaecati natus? Necessitatibus voluptate, cum ipsum nihil
        vero voluptatem placeat ad quos maxime nisi rerum quibusdam, ea
        explicabo repellat consequuntur laboriosam eius nulla. Accusamus
        blanditiis quod placeat temporibus, tempora, assumenda consequuntur qui
        vero tenetur sunt vitae laudantium officia, distinctio beatae ex
        consequatur minima autem quas ullam non repellendus! Expedita.
      </p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dicta
        voluptatum, reiciendis ipsa in, magni a cum beatae similique sint, quis
        vero vitae. Magnam, tenetur possimus! Iste qui ipsa commodi sunt non,
        accusantium vitae autem provident odit fuga dolore cumque exercitationem
        totam nesciunt error aliquam vel laborum, dolorum quas ullam sed
        consequuntur obcaecati natus? Necessitatibus voluptate, cum ipsum nihil
        vero voluptatem placeat ad quos maxime nisi rerum quibusdam, ea
        explicabo repellat consequuntur laboriosam eius nulla. Accusamus
        blanditiis quod placeat temporibus, tempora, assumenda consequuntur qui
        vero tenetur sunt vitae laudantium officia, distinctio beatae ex
        consequatur minima autem quas ullam non repellendus! Expedita.
      </p>
      <p>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Blanditiis
        illum debitis suscipit nostrum dignissimos impedit molestias ea,
        deleniti eum officia.
      </p>
      <p>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum sit,
        beatae nemo animi quos exercitationem nesciunt libero! Pariatur
        accusamus id quisquam laudantium assumenda quaerat veritatis, quod sint
        qui incidunt corrupti.
      </p>
      <p>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum sit,
        beatae nemo animi quos exercitationem nesciunt libero! Pariatur
        accusamus id quisquam laudantium assumenda quaerat veritatis, quod sint
        qui incidunt corrupti.
      </p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dicta
        voluptatum, reiciendis ipsa in, magni a cum beatae similique sint, quis
        vero vitae. Magnam, tenetur possimus! Iste qui ipsa commodi sunt non,
        accusantium vitae autem provident odit fuga dolore cumque exercitationem
        totam nesciunt error aliquam vel laborum, dolorum quas ullam sed
        consequuntur obcaecati natus? Necessitatibus voluptate, cum ipsum nihil
        vero voluptatem placeat ad quos maxime nisi rerum quibusdam, ea
        explicabo repellat consequuntur laboriosam eius nulla. Accusamus
        blanditiis quod placeat temporibus, tempora, assumenda consequuntur qui
        vero tenetur sunt vitae laudantium officia, distinctio beatae ex
        consequatur minima autem quas ullam non repellendus! Expedita.
      </p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dicta
        voluptatum, reiciendis ipsa in, magni a cum beatae similique sint, quis
        vero vitae. Magnam, tenetur possimus! Iste qui ipsa commodi sunt non,
        accusantium vitae autem provident odit fuga dolore cumque exercitationem
        totam nesciunt error aliquam vel laborum, dolorum quas ullam sed
        consequuntur obcaecati natus? Necessitatibus voluptate, cum ipsum nihil
        vero voluptatem placeat ad quos maxime nisi rerum quibusdam, ea
        explicabo repellat consequuntur laboriosam eius nulla. Accusamus
        blanditiis quod placeat temporibus, tempora, assumenda consequuntur qui
        vero tenetur sunt vitae laudantium officia, distinctio beatae ex
        consequatur minima autem quas ullam non repellendus! Expedita.
      </p>
      <p>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Blanditiis
        illum debitis suscipit nostrum dignissimos impedit molestias ea,
        deleniti eum officia.
      </p>
      <p>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum sit,
        beatae nemo animi quos exercitationem nesciunt libero! Pariatur
        accusamus id quisquam laudantium assumenda quaerat veritatis, quod sint
        qui incidunt corrupti.
      </p>
      <p>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum sit,
        beatae nemo animi quos exercitationem nesciunt libero! Pariatur
        accusamus id quisquam laudantium assumenda quaerat veritatis, quod sint
        qui incidunt corrupti.
      </p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dicta
        voluptatum, reiciendis ipsa in, magni a cum beatae similique sint, quis
        vero vitae. Magnam, tenetur possimus! Iste qui ipsa commodi sunt non,
        accusantium vitae autem provident odit fuga dolore cumque exercitationem
        totam nesciunt error aliquam vel laborum, dolorum quas ullam sed
        consequuntur obcaecati natus? Necessitatibus voluptate, cum ipsum nihil
        vero voluptatem placeat ad quos maxime nisi rerum quibusdam, ea
        explicabo repellat consequuntur laboriosam eius nulla. Accusamus
        blanditiis quod placeat temporibus, tempora, assumenda consequuntur qui
        vero tenetur sunt vitae laudantium officia, distinctio beatae ex
        consequatur minima autem quas ullam non repellendus! Expedita.
      </p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dicta
        voluptatum, reiciendis ipsa in, magni a cum beatae similique sint, quis
        vero vitae. Magnam, tenetur possimus! Iste qui ipsa commodi sunt non,
        accusantium vitae autem provident odit fuga dolore cumque exercitationem
        totam nesciunt error aliquam vel laborum, dolorum quas ullam sed
        consequuntur obcaecati natus? Necessitatibus voluptate, cum ipsum nihil
        vero voluptatem placeat ad quos maxime nisi rerum quibusdam, ea
        explicabo repellat consequuntur laboriosam eius nulla. Accusamus
        blanditiis quod placeat temporibus, tempora, assumenda consequuntur qui
        vero tenetur sunt vitae laudantium officia, distinctio beatae ex
        consequatur minima autem quas ullam non repellendus! Expedita.
      </p>
      <p>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Blanditiis
        illum debitis suscipit nostrum dignissimos impedit molestias ea,
        deleniti eum officia.
      </p>
      <p>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum sit,
        beatae nemo animi quos exercitationem nesciunt libero! Pariatur
        accusamus id quisquam laudantium assumenda quaerat veritatis, quod sint
        qui incidunt corrupti.
      </p>
      <p>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum sit,
        beatae nemo animi quos exercitationem nesciunt libero! Pariatur
        accusamus id quisquam laudantium assumenda quaerat veritatis, quod sint
        qui incidunt corrupti.
      </p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dicta
        voluptatum, reiciendis ipsa in, magni a cum beatae similique sint, quis
        vero vitae. Magnam, tenetur possimus! Iste qui ipsa commodi sunt non,
        accusantium vitae autem provident odit fuga dolore cumque exercitationem
        totam nesciunt error aliquam vel laborum, dolorum quas ullam sed
        consequuntur obcaecati natus? Necessitatibus voluptate, cum ipsum nihil
        vero voluptatem placeat ad quos maxime nisi rerum quibusdam, ea
        explicabo repellat consequuntur laboriosam eius nulla. Accusamus
        blanditiis quod placeat temporibus, tempora, assumenda consequuntur qui
        vero tenetur sunt vitae laudantium officia, distinctio beatae ex
        consequatur minima autem quas ullam non repellendus! Expedita.
      </p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dicta
        voluptatum, reiciendis ipsa in, magni a cum beatae similique sint, quis
        vero vitae. Magnam, tenetur possimus! Iste qui ipsa commodi sunt non,
        accusantium vitae autem provident odit fuga dolore cumque exercitationem
        totam nesciunt error aliquam vel laborum, dolorum quas ullam sed
        consequuntur obcaecati natus? Necessitatibus voluptate, cum ipsum nihil
        vero voluptatem placeat ad quos maxime nisi rerum quibusdam, ea
        explicabo repellat consequuntur laboriosam eius nulla. Accusamus
        blanditiis quod placeat temporibus, tempora, assumenda consequuntur qui
        vero tenetur sunt vitae laudantium officia, distinctio beatae ex
        consequatur minima autem quas ullam non repellendus! Expedita.
      </p>
      <p>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Blanditiis
        illum debitis suscipit nostrum dignissimos impedit molestias ea,
        deleniti eum officia.
      </p>
      <p>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum sit,
        beatae nemo animi quos exercitationem nesciunt libero! Pariatur
        accusamus id quisquam laudantium assumenda quaerat veritatis, quod sint
        qui incidunt corrupti.
      </p>
      <p>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum sit,
        beatae nemo animi quos exercitationem nesciunt libero! Pariatur
        accusamus id quisquam laudantium assumenda quaerat veritatis, quod sint
        qui incidunt corrupti.
      </p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dicta
        voluptatum, reiciendis ipsa in, magni a cum beatae similique sint, quis
        vero vitae. Magnam, tenetur possimus! Iste qui ipsa commodi sunt non,
        accusantium vitae autem provident odit fuga dolore cumque exercitationem
        totam nesciunt error aliquam vel laborum, dolorum quas ullam sed
        consequuntur obcaecati natus? Necessitatibus voluptate, cum ipsum nihil
        vero voluptatem placeat ad quos maxime nisi rerum quibusdam, ea
        explicabo repellat consequuntur laboriosam eius nulla. Accusamus
        blanditiis quod placeat temporibus, tempora, assumenda consequuntur qui
        vero tenetur sunt vitae laudantium officia, distinctio beatae ex
        consequatur minima autem quas ullam non repellendus! Expedita.
      </p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dicta
        voluptatum, reiciendis ipsa in, magni a cum beatae similique sint, quis
        vero vitae. Magnam, tenetur possimus! Iste qui ipsa commodi sunt non,
        accusantium vitae autem provident odit fuga dolore cumque exercitationem
        totam nesciunt error aliquam vel laborum, dolorum quas ullam sed
        consequuntur obcaecati natus? Necessitatibus voluptate, cum ipsum nihil
        vero voluptatem placeat ad quos maxime nisi rerum quibusdam, ea
        explicabo repellat consequuntur laboriosam eius nulla. Accusamus
        blanditiis quod placeat temporibus, tempora, assumenda consequuntur qui
        vero tenetur sunt vitae laudantium officia, distinctio beatae ex
        consequatur minima autem quas ullam non repellendus! Expedita.
      </p>
      <p>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Blanditiis
        illum debitis suscipit nostrum dignissimos impedit molestias ea,
        deleniti eum officia.
      </p>
      <p>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum sit,
        beatae nemo animi quos exercitationem nesciunt libero! Pariatur
        accusamus id quisquam laudantium assumenda quaerat veritatis, quod sint
        qui incidunt corrupti.
      </p>
      <p>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum sit,
        beatae nemo animi quos exercitationem nesciunt libero! Pariatur
        accusamus id quisquam laudantium assumenda quaerat veritatis, quod sint
        qui incidunt corrupti.
      </p>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dicta
        voluptatum, reiciendis ipsa in, magni a cum beatae similique sint, quis
        vero vitae. Magnam, tenetur possimus! Iste qui ipsa commodi sunt non,
        accusantium vitae autem provident odit fuga dolore cumque exercitationem
        totam nesciunt error aliquam vel laborum, dolorum quas ullam sed
        consequuntur obcaecati natus? Necessitatibus voluptate, cum ipsum nihil
        vero voluptatem placeat ad quos maxime nisi rerum quibusdam, ea
        explicabo repellat consequuntur laboriosam eius nulla. Accusamus
        blanditiis quod placeat temporibus, tempora, assumenda consequuntur qui
        vero tenetur sunt vitae laudantium officia, distinctio beatae ex
        consequatur minima autem quas ullam non repellendus! Expedita.
      </p>
    </main>
  )
}

export const demoData = {
  config: {
    fontFamily: "Rubik",
    stylesheetURL: 'https://fonts.googleapis.com/css2?family=Rubik:wght@400;500;600;700;800&display=swap',
    logo: "Logo",
  },
  theme: {
    header: {
      textColor: "#fff",
      bgColor: "#000",
      height: '60px'
    }
  }
}

export const simpleData = { product: simple, theme, config, translations }
export const variableData = { product: variable, theme, config, translations }
export const bundleData = { product: bundle, theme, config, translations }
export const buggyData = { product: buggy, theme, config, translations }
 